module.exports = __webpack_public_path__ + "static/assets/828132f0a12c52c7af7e4115ee768ed5.svg";